(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-section"] && !Shopify.designMode) return;
  try {
    ust


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
   $(".faq_accordion .faq_accordion_heading").click(function(){
    var value_1 = $(this).attr("data-id");
   $(".faq_accordion_content").each(function(){
    var value_2 = $(this).attr("data-class");
      if($(this).parents(".faq_accordion").find(".faq_accordion_heading ").hasClass("accordion_active")){
        $(this).slideUp()
        $(this).parents(".faq_accordion").find(".faq_accordion_heading  ").removeClass("accordion_active")
        $(this).parents(".faq_accordion").find(".faq_accordion_icon").text("+"); 
      } else{
    if(value_1 == value_2){
      $(this).parents(".faq_accordion").find(".faq_accordion_heading ").addClass("accordion_active")
      $(this).slideToggle();
      $(this).parents(".faq_accordion").find(".faq_accordion_icon ").text("-");
    }
      else{
        $(this).slideUp()
        $(this).parents(".faq_accordion").find(".faq_accordion_heading  ").removeClass("accordion_active")
        $(this).parents(".faq_accordion").find(".faq_accordion_icon ").text("+")
      }
      }
   });
 });

  } catch(e) { console.error(e); }
})();
})();
